/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



function getQueryStringParameters() {
     var parameters = {}, hash;
     var q = document.URL.split('?')[1];
     if(q != undefined) {
         q = q.split('&');
         for(var i = 0; i < q.length; i++) {
             hash = q[i].split('=');
             parameters[hash[0]] = hash[1];
         }
     }
     return parameters;
 }
function isEmpty(obj) {
 for(var key in obj) {
 if(obj.hasOwnProperty(key))
 return false;
 }
 return true;
}

function setupMenu() {
  if($(".subMenuWrapper").length > 0) {
    $(".subMenuWrapper").each(function(){
      console.log("Childcount"+ $(this).children().find(".childMenu").length);
      var child = $(this).children().find(".childMenu");
      child.children("li").each(function(){
        var subChild = $(this).children(".subChild2");
        if($(this).children(".subChild2").length > 0) {
          child.parent(".subMegaMenu").addClass("borderRight");
          
          if(subChild.children().find(".subChild3").length > 0) {
            $(this).children(".subChild2").addClass("borderRight");
          }
        }
      });
    });
  }
}
function setupNewMenu() {
  $(".nav1list > li").each(function(){
    if($(this).children(".navDropdown").length > 0) {
      if($(this).children(".navDropdown").children(".dropList").children("li").length > 7) {
        $(this).children(".navDropdown").children(".dropList").addClass("twoCols");
      }
      if($(this).children(".navDropdown").children(".dropList").children("li").length > 14) {
        $(this).children(".navDropdown").children(".dropList").removeClass("twoCols");
        $(this).children(".navDropdown").children(".dropList").addClass("threeCols");
      }
      if($(this).children(".navDropdown").children(".dropList").children("li").length > 21) {
        $(this).children(".navDropdown").children(".dropList").removeClass("twoCols");
        $(this).children(".navDropdown").children(".dropList").removeClass("threeCols");
        $(this).children(".navDropdown").children(".dropList").addClass("fourCols");
      }
    }
  });
}

$(function(){
  //setupMenu();
  setupNewMenu();
  var parameters = getQueryStringParameters();
   if(isEmpty(parameters) == false) {
   $.each(parameters, function(key, value) {
   	//console.log(key, value);
     
     if(value == "recover_customer_password") {
       if($("#recover_customer_password").length > 0) {
         $("#customer_login").hide();
         $("#recover_customer_password").show();
       }
     }
     if(key == "action" && value == "login") {
       console.log("tried to log in");
       if(!$("body").hasClass("user-loggedin")) {
         $(".formLogin .alert--error.error1").show();
         $(".multiForm").addClass("active");
         //location.replace("https://www.suppleo.co/");
         window.history.pushState({"":"","pageTitle":document.title},"", "https://www.suppleo.co/");
       }
       else {
         //$("#welcome-message").show();
       }
     }
     
   });
 }
  if($(".collectionSlider").length > 0) {
    $(".collectionSlider").slick({
      infinite: true,
      dots: true,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
      nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
    });
  }
  if($(".subcat-slider").length > 0) {
    /*$(".subcat-slider img").each(function(){
      var w = $(this).width();
      $(this).css({"height": w+"px"});
    });*/
    if($(".subcat-slider .subcategoryList li").length > 5) {
    $(".subcat-slider .subcategoryList").slick({
      infinite: true,
      dots: false,
      arrows: true,
      slidesToShow: 6,
      slidesToScroll: 3,
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
      nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
      responsive: [
              {
                breakpoint: 640,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  arrows: false
                }
              }
             ]
    });
      $(".subcat-slider").animate({"opacity": "1"}, 300);
    }
  }
  
  
  if($('.quick-links').length > 0) {
  $('.quick-links').slick({
      infinite: true,
       slidesToShow: 6,
       slidesToScroll: 4,
       dots: false,
       arrows: true,
       prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
       nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
    responsive: [
              {
                breakpoint: 640,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                }
              }
             ]
    });
  }
  
  if(isEmpty(parameters) == false) {
     $.each(parameters, function(key, value) {
       if(key == "target" && value == "wishlist") {
			$(".layout__section.page-section").hide();
         	$(".wishlist-section").show();
       }
     })
	}
  
});
function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}
$("body").on("click", ".formLogin input[type='submit']", function(event){
  var email = $(".formLogin input[type='email']").val();
  if(!validateEmail(email)) {
    $(".formLogin .alert--error.error2").show();
    return false;
  }
});
$("body").on("click", "#create_customer input[type='submit']", function(event){
  var email = $("#create_customer input[type='email']").val();
  if(!validateEmail(email)) {
    $("#create_customer .alert--error.error2").show();
    return false;
  }
});
$("body").on("click", ".nav2 .site-header__account", function(event){
  event.preventDefault();
  
});
$("body").on("click", ".triggerMultiForm", function(event){
  event.preventDefault();
  $(".multiForm").addClass("active");
});

$("body").on("click", ".multiForm .closepopup", function(event){
  $(".multiForm").removeClass("active");
  window.history.pushState({"":"","pageTitle":document.title},"", "https://www.suppleo.co/");
  $(".formLogin .alert--error.error1").hide();
});
//$(".singleForm").addClass("active");
$("body").on("click", ".singleForm .closepopup", function(event){
  Cookies.set('join-popup', '1', { expires: 1 });
  $(".singleForm").removeClass("active");
  $(".formLogin .alert--error.error1").hide();
});
$("body").on("click", "#block-footer-0 .rte p:eq(2) ", function(event){
  event.preventDefault();
  console.log("triggered");
  $("#chatra__iframe-wrapper").trigger("click");
});
$("body").on("click", ".multiForm .checkGroup input[type='checkbox']", function(){
  var userTypes = "";
  $(".multiForm .checkGroup .checkBox").each(function(){
    if($(this).children("input[type='checkbox']").is(":checked")) {
      if(userTypes != "") {
        userTypes += ","+$(this).children("input[type='checkbox']").val();
      }
      else {
        userTypes += $(this).children("input[type='checkbox']").val();
      }
    }
  });
  $(".multiForm #customer_tags").val(userTypes);
  $(".multiForm #customer_tags").attr("data-utypes", userTypes);
});

$("body").on("click", ".parentMenu > a", function(event){
  event.preventDefault();
  if($(this).parent("li").hasClass("active")) {
    $(this).parent("li").removeClass("active");
  }
  else {
  	$(".parentMenu").removeClass("active");
  	$(this).parent("li").addClass("active");
  }
});
$("body").on("click", ".tabBtn li", function(){
  var tabId = $(this).data("id");
  if(!$(this).hasClass("active")) {
    $(".tabBtn li").removeClass("active");
    $(this).addClass("active");
    $(".pd_info_box").removeClass("active");
    $(".pd_info_box[data-id='"+tabId+"']").addClass("active");
  }
});

$("body").on("click", "#editAccountInfo", function(event){
  event.preventDefault();
  console.log("clicked");
  $(".layout__section.page-section").stop().hide();
  $(".wishlist-section").stop().hide();
  $("#resetpassword").stop().show();
});
$("body").on("click", "#showWishlist", function(event){
  event.preventDefault();
  console.log("clicked");
  $(".layout__section.page-section").stop().hide();
  $("#resetpassword").stop().hide();
  $(".wishlist-section").stop().show();
});



$(window).on("load", function(){
  
  if(Cookies.get('join-popup') != "1") {
    if(!$("body").hasClass("template-captcha")) {
      if($(".singleForm").length > 0) {
        setTimeout(function(){
          //$(".singleForm").addClass("active");
          }, 1500);
      }
    }
  }
  
  if($("body").hasClass("template-index")) {
    setInterval(function(){
      if($("#insta-feed").length > 0) {
        if(!$("#insta-feed").hasClass("slick-slider")) {
          $("#insta-feed").slick({
            infinite: true,
            dots: false,
            arrows: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
       		nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
            responsive: [
              {
                breakpoint: 640,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                }
              }
             ]
          });
        }
      }
    }, 2000);
  }
});

$("body").on("mouseover", ".menuLevel1 > li", function(event){
  if($(this).children(".subChild2").length > 0) {
    $(this).parent().parent().parent(".subMenuWrapper").stop().addClass("active");
    $(this).stop().addClass("active");
  }
});
$("body").on("mouseout", ".menuLevel1 > li", function(event){
  $(this).parent().parent().parent(".subMenuWrapper").stop().removeClass("active");
  $(this).stop().removeClass("active");
});


$('body').on("click", "main#main, .header__logo, .header-search-form, .header__action-list, .nav2", function(e) {
  
  //var notF = $(".dropIcon");
        $(".parentMenu").removeClass("active");
      	$(".childMenu li").removeClass("active");
});
$('body').on("click", ".product-meta__share-buttons span", function(){
  $(this).next("ul").stop().slideToggle();
  console.log("Show social");
})


$(window).on("load resize", function(event){
  if($(window).width() <= 640) {
    if($("body").hasClass("template-product")) {
      $("h1.product-meta__title").insertBefore(".product-block-list__item--gallery");
      
      //$(".product-meta__share-buttons").appendTo(".product-form__info-list");
    }
  }
  else {
    if($("body").hasClass("template-product")) {
      //$("h1.product-meta__title").prependTo(".product-block-list__item--info .product-meta");
      //$(".product-meta__share-buttons").insertAfter(".card__section .product-form");
    }
  }
});

$('body').on("click", ".showLogin", function(event){
	event.preventDefault();
  $(".popupInner.formRegister").stop().hide();
  $(".popupInner.formLogin").stop().show();
});
$('body').on("click", ".showRegister", function(event){
	event.preventDefault();
  $(".popupInner.formLogin").stop().hide();
  $(".popupInner.formRegister").stop().show();
});


  $('body').on("click", ".nav1list>li>a", function(event){
    if($(window).width() < 1001) {
    	event.preventDefault();
    	$(this).next(".navDropdown").stop().slideToggle();
    	$(this).stop().toggleClass("active");
    }
  });
  $('body').on("click", ".nav2list>li>a", function(event){
    if($(window).width() < 1001) {
      if($(this).hasClass("site-header__account")) {
        event.preventDefault();
      }
      
      $(this).next(".submenu2").stop().slideToggle();
      $(this).stop().toggleClass("active");
    }
  });
$('body').on("click", "#ZoomyWishlistPage .zbodyaction button", function(event){
  setTimeout(function(){
    window.location.href = "/account/?target=wishlist";
  }, 3000);
});


$('body').on("click", "[data-action='toggle-menu1']", function(event){
  $(".nav2").addClass("active");
});
$('body').on("click", "#mobileClose", function(event){
  $(".nav2").removeClass("active");
});

$('body').on("click", ".site-header .header-search-form input[type='submit']", function(event){
  if($(window).width() < 791) {
    if(!$(this).prev(".boost-pfs-search-box").hasClass("is-filled")) {
      $(".site-header .header-search-form").toggleClass("active");
      $(".header__inner").toggleClass("search-active");
      console.log("hide");
    }
    else {
      $(".site-header .header-search-form").removeClass("active");
      $(".header__inner").removeClass("search-active");
    }
  }

});



   
$("body").on("click focus", ".site-header .header-search-form form input[type='text']", function(event){
  console.log("focus");
  event.preventDefault();
  event.stopPropagation();
});
















